import { GoalIntentGrid } from './GoalIntentGrid';
import { ScrollArea } from '../ui';
import styles from './EmptyDashboard.module.css';

/**
 * The catch-up home with nothing on it yet: the "What's your goal?" picker. Native parity —
 * `GoalIntentGrid.swift` / `GoalIntentGrid.kt`, from a catalog pinned to this one by
 * `native-apps/shared/goal-intents/briefs.json`.
 */
export function EmptyDashboard() {
  return (
    <ScrollArea className={styles.root}>
      <div className={styles.track}>
        <div className={styles.intro}>
          <GoalIntentGrid />
        </div>
      </div>
    </ScrollArea>
  );
}
